/** The game receives the iframe's real dimensions, so its usual layout rules run. */
export type TurnPanelSize = 'desktop' | 'phone' | 'landscape'
export function turnPanelViewport(size: TurnPanelSize, width: number, height: number) {
  if (size === 'phone') return { width: Math.min(width, 390), height }
  if (size === 'landscape') return { width: Math.min(width, 844), height: Math.min(height, 390) }
  return { width, height }
}
